module.exports = __webpack_public_path__ + "img/pura.7612a579.svg";